"use strict";

exports.__esModule = true;
exports.DataTableToolbar = exports.DOWNLOAD_SECONDS_FORMAT = exports.DOWNLOAD_HOUR_MINUTES_SECONDS_FORMAT = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _reactIntl = require("react-intl");
var _SearchInput = require("../SearchInput");
var _Toolbar = require("../../Core/Toolbar");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var ToolbarWrapper = _styledComponents["default"].div.withConfig({
  displayName: "DataTableToolbar__ToolbarWrapper",
  componentId: "sc-p0nfra-0"
})(["display:flex;flex:1 1 auto;width:100%;min-width:0;box-sizing:border-box;padding:0 calc(1rem - 5px);justify-content:space-between;text-align:left;.", "{margin-right:1em;flex-shrink:0;}.", ":last-child{margin-right:0;}"], _core.Classes.BUTTON, _core.Classes.BUTTON);
var SearchSlot = _styledComponents["default"].div.withConfig({
  displayName: "DataTableToolbar__SearchSlot",
  componentId: "sc-p0nfra-1"
})(["flex-grow:0;flex-shrink:0;width:12.5rem;max-width:100%;"]);
var DOWNLOAD_HOUR_MINUTES_SECONDS_FORMAT = exports.DOWNLOAD_HOUR_MINUTES_SECONDS_FORMAT = "hh mm ss";
var DOWNLOAD_SECONDS_FORMAT = exports.DOWNLOAD_SECONDS_FORMAT = "seconds";
var DataTableToolbar = exports.DataTableToolbar = function DataTableToolbar(props) {
  var reload = props.reload,
    downloadTableData = props.downloadTableData,
    handleSearchTermChange = props.handleSearchTermChange,
    _props$showReloadButt = props.showReloadButton,
    showReloadButton = _props$showReloadButt === void 0 ? true : _props$showReloadButt,
    _props$showDownloadBu = props.showDownloadButton,
    showDownloadButton = _props$showDownloadBu === void 0 ? true : _props$showDownloadBu,
    showDownloadDropdownButton = props.showDownloadDropdownButton,
    _props$downloading = props.downloading,
    downloading = _props$downloading === void 0 ? false : _props$downloading,
    editButtonComponent = props.editButtonComponent,
    _props$additionalSele = props.additionalSelectors,
    additionalSelectors = _props$additionalSele === void 0 ? false : _props$additionalSele;
  var _useState = (0, _react.useState)(""),
    searchTerm = _useState[0],
    _ = _useState[1];
  var EditButton = editButtonComponent;
  return /*#__PURE__*/_react["default"].createElement(ToolbarWrapper, {
    "data-testid": "DataTable.Toolbar"
  }, /*#__PURE__*/_react["default"].createElement(_Toolbar.LeftToolbarContent, null, /*#__PURE__*/_react["default"].createElement(SearchSlot, {
    "data-testid": "DataTable.SearchSlot"
  }, /*#__PURE__*/_react["default"].createElement(_SearchInput.DebouncedSearchInput, {
    value: searchTerm,
    onChange: handleSearchTermChange,
    debounceDuration: 200
  }))), /*#__PURE__*/_react["default"].createElement(_Toolbar.RightToolbarContent, null, EditButton ? /*#__PURE__*/_react["default"].createElement(EditButton, {
    reload: reload
  }) : null, additionalSelectors, showReloadButton && /*#__PURE__*/_react["default"].createElement(_core.Button, {
    "data-testid": "DataTable-ReloadButton",
    small: true,
    minimal: true,
    type: "button",
    icon: "refresh",
    onClick: reload,
    disabled: typeof reload !== "function"
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "DataTable.Reload",
    defaultMessage: "Reload"
  })), showDownloadButton && showDownloadDropdownButton && /*#__PURE__*/_react["default"].createElement(_core.Popover, {
    content: /*#__PURE__*/_react["default"].createElement(_core.Menu, null, /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
      "data-testid": "DataTable-DownloadButtonDropdown-HoursMinutesSeconds",
      icon: _icons.IconNames.DOWNLOAD,
      text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "ContextMenu.download.asTimeFormat",
        defaultMessage: "As hours, minutes, seconds"
      }),
      onClick: function onClick() {
        return downloadTableData(DOWNLOAD_HOUR_MINUTES_SECONDS_FORMAT);
      }
    }), /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
      "data-testid": "DataTable-DownloadButtonDropdown-AsSeconds",
      icon: _icons.IconNames.DOWNLOAD,
      text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "ContextMenu.download.asSeconds",
        defaultMessage: "As seconds"
      }),
      onClick: function onClick() {
        return downloadTableData(DOWNLOAD_SECONDS_FORMAT);
      }
    })),
    placement: "bottom"
  }, /*#__PURE__*/_react["default"].createElement(_core.Button, {
    "data-testid": "DataTable-DownloadButtonDropdown",
    minimal: true,
    icon: _icons.IconNames.DOWNLOAD,
    loading: downloading
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "ContextMenu.download",
    defaultMessage: "Download"
  }))), showDownloadButton && !showDownloadDropdownButton && /*#__PURE__*/_react["default"].createElement(_core.Button, {
    "data-testid": "DataTable-DownloadButton",
    small: true,
    minimal: true,
    icon: _icons.IconNames.DOWNLOAD,
    loading: downloading,
    onClick: downloadTableData
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "ContextMenu.download",
    defaultMessage: "Download"
  }))));
};